import { useTranslation } from 'react-i18next';
import {
  MoreVertical,
  Download,
  Share2,
  Edit,
  Trash2,
} from 'lucide-react';
import { ActionMenu, IconButton } from '@ntconsult/aluma-react';

interface ResourceActionMenuProps {
  canWrite?: boolean;
  isInteractive?: boolean;
  onDownload?: () => void;
  onShare?: () => void;
  onEdit?: () => void;
  onDelete?: () => void;
}

export function ResourceActionMenu({
  canWrite = true,
  isInteractive = true,
  onDownload,
  onShare,
  onEdit,
  onDelete,
}: ResourceActionMenuProps) {
  const { t } = useTranslation('common');

  return (
    <div
      onClick={(e) => e.stopPropagation()}
      className="[@media(hover:hover)]:opacity-0 [@media(hover:hover)]:group-hover:opacity-100 [@media(hover:hover)]:focus-within:opacity-100 transition-opacity"
    >
      <ActionMenu
        align="right"
        trigger={
          <IconButton
            variant="ghost"
            size="sm"
            label={t('actions.openMenu')}
            icon={<MoreVertical className="w-4 h-4" aria-hidden="true" />}
          />
        }
      >
        {onDownload && isInteractive && (
          <ActionMenu.Item
            icon={<Download className="w-4 h-4" aria-hidden="true" />}
            onClick={onDownload}
          >
            {t('actions.download')}
          </ActionMenu.Item>
        )}
        {onShare && isInteractive && (
          <ActionMenu.Item
            icon={<Share2 className="w-4 h-4" aria-hidden="true" />}
            onClick={onShare}
          >
            {t('actions.share')}
          </ActionMenu.Item>
        )}
        {onEdit && canWrite && (
          <ActionMenu.Item
            icon={<Edit className="w-4 h-4" aria-hidden="true" />}
            onClick={onEdit}
          >
            {t('actions.rename')}
          </ActionMenu.Item>
        )}
        {onDelete && canWrite && (
          <ActionMenu.Item
            variant="danger"
            icon={<Trash2 className="w-4 h-4" aria-hidden="true" />}
            onClick={onDelete}
          >
            {t('actions.delete')}
          </ActionMenu.Item>
        )}
      </ActionMenu>
    </div>
  );
}
